import { getServiceList, getServiceById, addService, updateService, updateProjectOrderNoticeImg, delServiceById } from '@/api/home/service'
import { useUserStore } from '@/store'
import { message } from 'ant-design-vue'

export enum CATEGORY {
  headquarters = 'headquarters',
  'massage' ='massage',
  'housekeeping' = 'housekeeping'
}

export class ServiceController {
  static async page (params: {category: string}) {
    return await getServiceList({
      category: useUserStore().userInfo.agent.category
    })
  }

  static async add (data: HOME.SERVER) {
    const { code, msg } = await addService(data)
    code === 0 ? message.success('添加成功') : message.error(msg)
    return code
  }

  static async update (data: HOME.SERVER) {
    const { code, msg } = await updateService(data)
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }

  static async del (id: string) {
    const { code, msg } = await delServiceById(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
    return code
  }

  static async byId (id: string) {
    return (await getServiceById(id)).data
  }

  static async updateProjectOrderNoticeImg (projectId: string, url: string) {
    const { code, msg } = await updateProjectOrderNoticeImg(projectId, url)
    code === 0 ? message.success('修改成功') : message.error(msg)
    return code
  }
}
